import * as id from './home-id';
import * as en from './home-en';

export function getHomeContent(locale) {
  return locale === 'en' ? en : id;
}
